import React, { FC, useState } from 'react';
import { useFlags } from '@fullstory/react-hooks';
import { Flag } from '@fullstory/proto/fs/shared/flags';
import { Button } from '@fullstory/components';
import { FormattedMessage } from 'react-intl';
import { DeleteUserModalContainer } from '../DeleteUserModal';
import { UserDetailsResponse } from '@fullstory/client-api';
import { bestDisplayNameforUser } from '@fullstory/util/utils';

type UserOverlayDeleteUserBtnProps = { userDetails: UserDetailsResponse; userId: string };
export const UserOverlayDeleteUserBtn: FC<UserOverlayDeleteUserBtnProps> = ({
  userDetails,
  userId,
}) => {
  const [showUserDeleteModal, setShowUserDeleteModal] = useState(false);
  const flags = useFlags();
  return (
    <>
      {flags?.hasBit(Flag.PermDeleteUserData) ? (
        <Button
          variant="fill-destructive"
          fullWidth
          onClick={() => {
            setShowUserDeleteModal(true);
          }}
          justifyContent="center"
        >
          <FormattedMessage defaultMessage="Delete user" id="TCx4hN" />
        </Button>
      ) : null}
      {showUserDeleteModal && userDetails && (
        <DeleteUserModalContainer
          userId={userId}
          appId={userDetails?.UserAppId}
          userName={bestDisplayNameforUser(userDetails.UserDisplayName, userDetails.UserEmail)}
          onCloseSignal={() => {
            setShowUserDeleteModal(false);
          }}
        />
      )}
    </>
  );
};
